import { HttpClient, HttpHeaders, HttpParams, HttpUrlEncodingCodec } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { SessionStorageService,LocalStorage, LocalStorageService } from 'ngx-webstorage';
import { BehaviorSubject, Observable } from 'rxjs';
import { Page } from '../components/model/pagination/page';
import { UserData } from '../components/model/user-data';
import { Usersearch } from "../components/model/usersearch";
import { UsersDataResponse } from '../components/model/users-data-response';
import { AppConstants } from '../constants/app.constants';
const TOKEN_ENDPOINT = 'https://login.microsoftonline.com/55ab44f3-be48-4bbb-bb8d-a860780fd8a8/oauth2/v2.0/token';
@Injectable({
  providedIn: 'root'
})
export class UserService {
  profile;
  public currentUser = new BehaviorSubject(new UsersDataResponse());
  public profileUserData= new BehaviorSubject(new UsersDataResponse());

  constructor(private httpClient: HttpClient, private session: SessionStorageService,private localstorage:LocalStorageService) { }

  userdataresponse: UsersDataResponse
  getLoginUserData(): Observable<UsersDataResponse> {
    return this.httpClient.get<UsersDataResponse>
      (AppConstants.GET_LOGGED_USER_INFO);
  }
  getUserDataByUPN(upn: string): Observable<UsersDataResponse> {
    return this.httpClient.get<UsersDataResponse>
      (AppConstants.GET_USER_INFO + "?upn=" + upn);
  }

  getSCGlogout(): Observable<any>{
    return this.httpClient.get<any>
      ("https://dcn-esign-np-gateway-uat.apps.pvtgfpte.ngco.com/scg-logout");
  }

  getAzureLogout(): Observable<any>{
    return this.httpClient.get<any>
      ("https://login.microsoftonline.com/eaa6cb52-58d7-45cd-8bd6-b1d2a8e61312/oauth2/v2.0/logout");
  }


  getUserDataBySeq(sequenceNumber: number): Observable<UsersDataResponse> {
    return this.httpClient.get<UsersDataResponse>
    (AppConstants.GET_USER_SEQ + "/" + encodeURIComponent(sequenceNumber));
  }

  getAllUsersByStore(status: string,dcNumber:number,storeNumber:string,roleId:string, sort: string, order: string,  pageNumber: number,pageSize:number): Observable<Page<UsersDataResponse>> {
    if(sort===undefined){
      sort='';
     }
    return this.httpClient.get<Page<UsersDataResponse>>
      (AppConstants.GET_ALLUSERS_INFO + "?status="+ status +"&dcNumber="+dcNumber+"&storeNumber="+storeNumber+"&roleAccessIds="+roleId+"&pageNo="+pageNumber+"&pageSize="+pageSize+"&sort="+sort+"&order="+order);
  }
  
  getAllUsersByDC(status: string,dcNumber:number,storeNumber:string,roleId:string, sort: string, order: string,  pageNumber: number,pageSize:number): Observable<Page<UsersDataResponse>> {
    if(sort===undefined){
      sort='';
     }
    return this.httpClient.get<Page<UsersDataResponse>>
      (AppConstants.GET_ALLUSERS_INFO + "?status="+ status +"&dcNumber="+dcNumber+"&storeNumber="+storeNumber+"&roleAccessIds="+roleId+"&pageNo="+pageNumber+"&pageSize="+pageSize+"&sort="+sort+"&order="+order);
  }

  getUsersByStore(storeNumber:string): Observable<Usersearch[]> {
    
    return this.httpClient.get<Usersearch[]>
      (AppConstants.GET_USERS_BY_STORE + "?status="+'Y'+"&storeNumber="+storeNumber);
  }
  getUsersByStoreAll(storeNumber:string): Observable<Usersearch[]> {
    
    return this.httpClient.get<Usersearch[]>
      (AppConstants.GET_ALLUSERS_BY_STORE + "?storeNumber="+storeNumber);
  }
  
  updateusa(upn: string): Observable<Number> {
    return this.httpClient.put<Number>
      (AppConstants.UPDATE_ESA + "?upn=" + upn,null);
  }

  updateLogoutStatus(sequenceNumber: number): Observable<Number> {
    window.sessionStorage.clear();
    window.localStorage.clear();
    return this.httpClient.put<Number>
      (AppConstants.UPDATE_LOGOUT + "?sequenceNumber="+sequenceNumber,null);
  }

  updateESignAttestation

  saveUser(userdataresponse: UserData){
    return this.httpClient.post<UserData>(AppConstants.SAVE_USERS_INFO,userdataresponse);
  }

  saveProfile(userdataresponse: UserData){     
    return this.httpClient.put<number>(AppConstants.SAVE_USERS_PROFILE,userdataresponse);
  }

  setObject(key,value){
    this.session.store(key, value);
  }
  getObject(key){
  return  this.session.retrieve(key);
  }
  removeObject(key){
    return  this.session.clear();
    }
  setCurrentUser(user: UsersDataResponse) {
    this.session.store("currentuser", user);
    this.profileUserData.next(user); 
  }
  setLocalStorageObject(key,value){
    this.localstorage.store(key, value);
  }
  getLocalStorageValue(key){
    return this.localstorage.retrieve(key);
  }
  setUnauthorized(){
    this.localstorage.store('unauthorized', true); 
  }
  resetUnauthorized(){
    this.localstorage.store('unauthorized', false); 
  }
  getUnauthorizedState(){
   return this.localstorage.retrieve('unauthorized'); 
  }
  setLogin(){
    this.localstorage.store('logged-in', true);
  }
  getLoginState(){
  return this.localstorage.retrieve('logged-in');
  }
  setLogOut(){
    this.localstorage.store('logged-in', false);
  }
  getCurrentUser() {
   let user= this.session.retrieve("currentuser")
   if(user===null){
     this.getLoginUserData().subscribe(data=>{
    return  this.currentUser.next(data);
     })
   }else{
    this.currentUser.next(user);
    return this.currentUser;
   }
  }

 
  getAllProvinces(): Observable<string[]> {
    return this.httpClient.get<string[]>
      (AppConstants.GET_PROVINCES);
  }

  getNCTMUserAccess(upn:string): Observable<boolean> {
    return this.httpClient.get<boolean>
      (AppConstants.GET_NCTM_USER_ACCESS+"/"+upn);
  }

}
